<script setup>
import InputVue from './InputCompVue'

import { ref, useTemplateRef } from 'vue'

const { modelValue, options } = defineProps({
  name: String,
  label: String,
  cssClasses: String,
  labelAsPlaceholder: Boolean,
  placeholder: String,
  modelValue: {
    type: String,
    default: '',
  },
  alignment: {
    type: String,
    default: 'horizontal',
  },
  options: {
    type: [Array, Object],
    default: [],
  },
})
const emit = defineEmits([
  'update:modelValue',
])
const hasError = ref(false)
const inputEl = useTemplateRef('inputEl')
const val = ref(modelValue)
const o = ref(options)

const onChange = (e) => {
  console.log('change', e)
  val.value = e.target.value
  emit('update:modelValue', val.value)
}

const onInput = (e) => {
  console.log('input', e, e.target.value)
  val.value = e.target.value
  emit('update:modelValue', val.value)
}

console.log(val.value, modelValue, options, o)

const reset = () => {
}

const getValue = () => {
  return val.value
}

const focusInput = () => {
  inputEl.value.focus()
}

defineExpose({ reset, getValue })

</script>

<template>
  <InputVue
    :name="name"
    :label="label"
    :tabindex="0"
    class="select-input-cont"
    :cssClasses="cssClasses"
    :labelAsPlaceholder="labelAsPlaceholder"
    :hasError="hasError"
    :alignment="alignment"
    @input="onInput">
    <template #input-slot>
      <div class="select-input-wrapper">
        <select class="form-control" :value="modelValue">
          <option
            v-for="(opt, k) in options"
            :key="k"
            :value="k"
            @change="onChange">
            {{opt}}
          </option>
        </select>
      </div>
    </template>
  </InputVue>
</template>

<style lang="scss" scoped>
.select-input-vue-wrapper {
}
</style>
